import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import OrderBookType from 'enums/shared/orderBookType';
import useAppTheme from 'hooks/shared/useAppTheme';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import nFormatter from 'utils/nFormatter';

interface Props {
  item: OrderBookItem;
  type: OrderBookType;
  filledPercent: number;
}

const OrderBookTableRow: FC<Props> = ({ item, type, filledPercent }) => {
  const theme = useAppTheme();

  const rowHeight = '40px';
  const bgColor =
    type === OrderBookType.Buy
      ? theme.colors[Color.Primary500]
      : theme.colors[Color.Danger400];
  const textColor =
    type === OrderBookType.Buy
      ? theme.colors[Color.Profit]
      : theme.colors[Color.Loss];
  const fillAlignment = type === OrderBookType.Buy ? 'right' : 'left';
  let textContent;
  if (type === OrderBookType.Buy) {
    textContent = (
      <>
        <Text>{item.price.toFixed(2)}</Text>
        <Text color={textColor}>{nFormatter(item.count, 1)}</Text>
      </>
    );
  } else {
    textContent = (
      <>
        <Text color={textColor}>{nFormatter(item.count, 1)}</Text>
        <Text>{item.price.toFixed(2)}</Text>
      </>
    );
  }

  return (
    <>
      <Box pos="relative" h={rowHeight} py="10px">
        <Flex
          justifyContent="space-between"
          pos="relative"
          h={rowHeight}
          w="full"
          zIndex="2"
        >
          {textContent}
        </Flex>
        <Box
          pos="absolute"
          top="10px"
          left={fillAlignment === 'left' ? 0 : undefined}
          right={fillAlignment === 'right' ? 0 : undefined}
          h="20px"
          w={`${filledPercent * 100}%`}
          bgColor={bgColor}
          opacity="0.2"
          borderRadius="2px"
          zIndex="1"
        />
      </Box>
      <Divider />
    </>
  );
};

export default OrderBookTableRow;
